module.exports = __webpack_public_path__ + "static/media/city1.e759d25e.jpg";